const CSRF_TOKEN_META_SELECTOR = 'meta[name="csrf-token"]';

export const getCsrfToken = () =>
    document
        .querySelector<HTMLMetaElement>(CSRF_TOKEN_META_SELECTOR)
        ?.getAttribute('content') || '';

export const csrfTokenHeader = (): Record<string, string> => {
    const csrfToken = getCsrfToken();

    return csrfToken ? { 'X-CSRF-Token': csrfToken } : {};
};

export const updateCsrfToken = (csrfToken: unknown) => {
    if (typeof csrfToken !== 'string' || csrfToken.length === 0) {
        return;
    }

    let csrfTokenMeta = document.querySelector<HTMLMetaElement>(
        CSRF_TOKEN_META_SELECTOR,
    );

    if (!csrfTokenMeta) {
        csrfTokenMeta = document.createElement('meta');
        csrfTokenMeta.name = 'csrf-token';
        document.head.appendChild(csrfTokenMeta);
    }

    csrfTokenMeta.setAttribute('content', csrfToken);
};
